<input
  #inputEl
  type="file"
  [class]="computedClasses"
  [attr.accept]="accept || null"
  [attr.aria-label]="ariaLabel || null"
  [disabled]="disabled"
  (change)="onChange($event)" />

